module.exports = __webpack_public_path__ + "img/detection_dossiers_multiples.b127adc1.png";